export default class Membership {
    constructor(membershipIsVisible, studentDiscount, urlRouteMembershipChange, linkCartUrl) {
        this.checkoutNextButtonsSelector = $("#checkout-bottom, #checkout-bottom-mobile, #checkout-booklist");
        this.studentDiscount = studentDiscount;
        this.memberShipIsVisible = membershipIsVisible;
        this.urlRouteMembershipChange = urlRouteMembershipChange;
        this.linkCartUrl = linkCartUrl

        function membershipOptionsChecked(clickEvent) {
            if (!$('input[name="MembershipType"]:checked').val()) {
                clickEvent.preventDefault();
                $('#studentMembershipValidation').css('display', 'block');
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        }

        if ($('input[name="MembershipType"]').length > 0) {
            this.checkoutNextButtonsSelector.on("click", clickEvent => {
                membershipOptionsChecked(clickEvent);
            });
        }
    }

    submitMembershipChange(membershipValue) {
        const membershipType = membershipValue;
        const membership = $.get(`${this.urlRouteMembershipChange}?type=${membershipType}`).done(() => {
            $('#link-cart').load(this.linkCartUrl);
        });
        
        return this.membershipTypeIsJoin(membershipType) || membershipType.toLowerCase() === 'member';
    }

    overridePriceElements() {
        return $('.product-list__price.product-list__price_from-to');
    }

    membershipTypeIsJoin(membershipType) {
        return membershipType.toLowerCase() === 'join';
    }
}